import { Component } from '@angular/core';
import { NgClass, NgStyle} from '@angular/common';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { Http, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { LoginPage } from '../../pages/login/login';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Events } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'event-modal-page',
    templateUrl: './event-modal.html',

})

export class EventModalPage {

public iBytesUploaded = 0;
public  iBytesTotal = 0;
public iPreviousBytesLoaded = 0;
public iMaxFilesize = 1048576; // 1MB
public oTimer = 0;
public sResultFileSize = '';
public ficheros;
public visto:string = "NO";
public fecha;
//nombre;
public codigo = "s"; 
public ficherocompleto = {};

    constructor(
    public navCtrl: NavController,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public params: NavParams,
    public viewCtrl: ViewController,
    public variables:VariablesProvider,
    public http: Http,
    public events: Events,

    ) {
    //this.nombre = params.get('nombre');
    this.codigo = params.get('codigo');
    this.loadData();
    }



    loadData(){
      this.variables.getficheros(this.codigo)
      .then(
          data => {
            this.ficheros = data;
          }
        )
        .catch(
          error => {
            console.log(error);
          }
        )
    }



  abrirfichero(value, fichero){
    window.open(value, "_blank");
    this.visto = "SI";
    this.variables.nombrefichero = fichero;
    var fichero;
    var f = new Date();
    this.fecha =  f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ;
    /*
    //console.log("EL CODIGO " + this.codigo);
    //console.log("LA FECHA " + this.fecha);
    //console.log("VISTO " + this.visto);
    //console.log("NOMBRE FICHERO " + fichero);
    */
    this.variables.ficheroabierto(this.codigo , this.fecha, this.visto, this.variables.nombrefichero);        
    //this.navCtrl.setRoot(this.navCtrl.getActive().component);
  }  

  abrirfichero2(value){
    window.open(value, "_blank");
  } 

   dismiss() {
    //console.log("Se va...");
    this.viewCtrl.dismiss(
      {
        //CODIGO DISMISS
      }
    ); }



 fileSelected() {

    // hide different warnings
    document.getElementById('upload_response').style.display = 'none';
    document.getElementById('error').style.display = 'none';
    document.getElementById('error2').style.display = 'none';
    document.getElementById('abort').style.display = 'none';
    document.getElementById('warnsize').style.display = 'none';

    // get selected file element
    //var oFile = document.getElementById('image_file').files[0];

    document.getElementById("image_file").onchange= function(e: Event) {
        var oFile = (<HTMLInputElement>e.target).files[0];

    }

}

 startUploading() {
    // cleanup all temp states
    this.iPreviousBytesLoaded = 0;
    document.getElementById('upload_response').style.display = 'none';
    document.getElementById('error').style.display = 'none';
    document.getElementById('error2').style.display = 'none';
    document.getElementById('abort').style.display = 'none';
    document.getElementById('warnsize').style.display = 'none';
    document.getElementById('progress_percent').innerHTML = '';
    var oProgress = document.getElementById('progress');
    oProgress.style.display = 'block';
    oProgress.style.width = '0px';

    var formEl = <HTMLFormElement> document.getElementById("upload_form");
    var vFD = new window['FormData'](formEl);


    var oXHR = new XMLHttpRequest();   

     return new Promise((resolve, reject) => {

    oXHR.upload.addEventListener('progress', this.uploadProgress, false);
    oXHR.addEventListener('load', this.uploadFinish, false);
    oXHR.addEventListener('error', this.uploadError, false);
    oXHR.addEventListener('abort', this.uploadAbort, false);

    oXHR.addEventListener("reload", function () {
             //window.location.reload();
    });
    
     oXHR.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
           //document.getElementById("upload_form").innerHTML = this.responseText;
       }
    };
    
    oXHR.open('POST', 'http://www.panel-control.com/picademo/recursos/php2.php/', true);
    oXHR.send(vFD) ;
  });

    //this.oTimer = setInterval(this.doInnerUpdates, 300);
}

 doInnerUpdates() { 
    var iCB = this.iBytesUploaded;
    var iDiff = iCB - this.iPreviousBytesLoaded;

    // if nothing new loaded - exit
    if (iDiff == 0)
        return;

    this.iPreviousBytesLoaded = iCB;
    iDiff = iDiff * 2;
    var iBytesRem = this.iBytesTotal - this.iPreviousBytesLoaded;
    var secondsRemaining = iBytesRem / iDiff;

    // update speed info
    var iSpeed = iDiff.toString() + 'B/s';
    if (iDiff > 1024 * 1024) {
        iSpeed = (Math.round(iDiff * 100/(1024*1024))/100).toString() + 'MB/s';
    } else if (iDiff > 1024) {
        iSpeed =  (Math.round(iDiff * 100/1024)/100).toString() + 'KB/s';
    }

    document.getElementById('speed').innerHTML = iSpeed;
  //  document.getElementById('remaining').innerHTML = '| ' + secondsToTime(secondsRemaining);        
}

 uploadProgress(e) { // upload process in progress
    if (e.lengthComputable) {
        this.iBytesUploaded = e.loaded;
        this.iBytesTotal = e.total;
        var iPercentComplete = Math.round(e.loaded * 100 / e.total);
        //var iBytesTransfered = this.bytesToSize(this.iBytesUploaded);

        document.getElementById('progress_percent').innerHTML = iPercentComplete.toString() + '%';
        document.getElementById('progress').style.width = (iPercentComplete * 4).toString() + 'px';
        //document.getElementById('b_transfered').innerHTML = iBytesTransfered;
        if (iPercentComplete == 100) {
            var oUploadResponse = document.getElementById('upload_response');
            oUploadResponse.innerHTML = '<h3>Subiendo fichero...</h3>';
            oUploadResponse.style.display = '';

        }
    } else {
        document.getElementById('progress').innerHTML = 'unable to compute';
    }
}

 uploadFinish(e) { // upload successfully finished
    var oUploadResponse = document.getElementById('upload_response');
    oUploadResponse.innerHTML = e.target.responseText;
    oUploadResponse.style.display = '';

    document.getElementById('progress_percent').innerHTML = '100%';
    document.getElementById('progress').style.width = '100px';
   // document.getElementById('filesize').innerHTML = this.sResultFileSize;
    //document.getElementById('remaining').innerHTML = '| 00:00:00';
    clearInterval(this.oTimer);
    //this.navCtrl.setRoot(this.navCtrl.getActive().component);
}

 uploadError(e) { // upload error
    document.getElementById('error2').style.display = '';
    clearInterval(this.oTimer);
}  
uploadAbort(e) { // upload abort
    document.getElementById('abort').style.display = '';
    clearInterval(this.oTimer);
}

reloadPage(e) { // upload abort
    document.getElementById('reload').style.display = '';
    
    clearInterval(this.oTimer);
}



}





// WEBPACK FOOTER //
// ./src/pages/event-modal/event-modal.ts